import React, { useState, useEffect } from 'react'
import { GetAvailableSiteAdmins, GetSites } from '../../services/sites/sites'
import CustomSelect from './CustomSelect'
import { error, success } from '../../constants/msg'
import { FIELD } from '../../constants/app-constants'
import { competency_select_options } from '../../utils/constants'

const CustomCompetencySelect = (props) => {
    return (
        <CustomSelect
            {...props}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            isLoading={false}
            isClearable={props.isClearable}
            options={competency_select_options}
        />
    )
}

export default CustomCompetencySelect